import React from 'react';
var css = {
  "tabTitle": "rui-ouaiH",
  "smallTitle": "rui-Q13HY",
  "tabLabel": "rui-7CIJX",
  "roundedBorder": "rui-7OGKR",
  "activeLabel": "rui-q7otw",
  "progessBarAnimation": "rui-oB0Ko",
  "progressAnimation": "rui-MeJNI",
  "disabledLabel": "rui-TgcsP"
};
var TabTitle = function TabTitle(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    progressAnimation = _ref.progressAnimation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: css.tabTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css.title || '', " ").concat(subTitle ? css.smallTitle : '')
  }, title), subTitle && /*#__PURE__*/React.createElement("div", {
    className: css.subTitle
  }, subTitle)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css.roundedBorder, " ").concat(progressAnimation ? css.progessBarAnimation : '')
  }));
};
export default TabTitle;